import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_2 = {
  key: 1,
  class: "mt-4"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "material-icons mr-4" }
const _hoisted_5 = {
  key: 0,
  class: "text-bookmark dark:text-bookmark-dark"
}
const _hoisted_6 = {
  key: 1,
  class: "text-gray-500 dark:text-dark-text"
}
const _hoisted_7 = { class: "text-lg font-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (!_ctx.isLogin)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bookmarkPresenter.bookmark.value.problems, (problem) => {
          return (_openBlock(), _createElementBlock("div", {
            key: problem.id,
            class: "hover-hand border rounded my-1 flex items-center p-4 hover:shadow transition duration-100 hover:border-bookmark text-gray-900 dark:hover:border-bookmark-dark dark:border-dark-400 dark:text-dark-text dark:bg-dark-500",
            onClick: ($event: any) => (_ctx.clickProblem(problem.id))
          }, [
            _createElementVNode("span", _hoisted_4, [
              (problem.isSolved)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, " check_circle "))
                : (_openBlock(), _createElementBlock("span", _hoisted_6, " radio_button_unchecked "))
            ]),
            _createElementVNode("p", _hoisted_7, _toDisplayString(problem.id) + " : " + _toDisplayString(problem.name), 1)
          ], 8, _hoisted_3))
        }), 128))
      ]))
}